/* !function(){"use strict";customElements.get("contact-form-message")||customElements.define("contact-form-message",class extends HTMLElement{constructor(){super()}connectedCallback(){this.hidePopups(),this.closeFormMessage(),this.autoHideMessage()}hidePopups(){document.body.classList.add("notification-visible")}showPopups(){document.body.classList.remove("notification-visible")}closeFormMessage(){this.querySelector("[data-form-message-close]").addEventListener("click",this.closeMessage.bind(this))}closeMessage(s){s.preventDefault(),this.classList.add("hide-down"),this.showPopups()}autoHideMessage(){setTimeout((()=>{this.classList.add("hide-down"),this.showPopups()}),1e4)}})}();
*/
!(function () {
    "use strict";
    customElements.get("contact-form-message") ||
        customElements.define(
            "contact-form-message",
            class extends HTMLElement {
                constructor() {
                    super();
                }
                connectedCallback() {
                    this.hidePopups(),
                        this.closeFormMessage(),
                        this.autoHideMessage();
                }
                hidePopups() {
                    document.body.classList.add("notification-visible");
                }
                showPopups() {
                    document.body.classList.remove("notification-visible");
                }
                closeFormMessage() {
                    this.querySelector(
                        "[data-form-message-close]"
                    ).addEventListener("click", this.closeMessage.bind(this));
                }
                closeMessage(s) {
                    s.preventDefault(),
                        this.classList.add("hide-down"),
                        this.showPopups();
                }
                autoHideMessage() {
                    const section = this.closest('section');
                    if (section) {
                    const y =
                        section.getBoundingClientRect().top +
                        window.pageYOffset -
                        100;

                    window.scrollTo({
                        top: y,
                        behavior: 'smooth'
                    });
                    }
                    setTimeout(() => {
                        this.classList.add("hide-down"), this.showPopups();
                    }, 1e4);
                }
            }
        );
})();
